import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import MarketsContext from "context/MarketsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateServiceOrder from "./CreateServiceOrder";
import UserService from "services/UserService";
import axios from "axios";
import { getMarketMembershipOrders } from "services/ConfigServices";
import {
  memberorderTypeData,
  memberorderStatusData,
  memberorderElectricitySegment,
  memberorderElectricityTurpeVersionC5,
  memberorderElectricityTurpeVersionC4C3C2,
  memberorderElectricityTurpeVersionC5Ecl,
  memberorderElectricityEclHourCount,
  memberorderElectricityRenewableMix,
  memberorderGasProfil,
  memberorderGasTariff
} from "variables/lists/markets";
import { memberorder } from "variables/markets";
import moment from "moment";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useServiceOrderTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const markets_admin = permis.includes("markets_admin");
  const markets_update = permis.includes("markets_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMarketMembershipOrders(chartIdGroup, market.id);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );


  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        <CreateServiceOrder refetch={refreshTable} onClick={onUpload} />
      </UploadButton>
    </>
  );

  const filteredItems = _.get(results, `orders`, []).filter(
    (item) =>
      (item.parameters.pdl && item.parameters.pdl.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.numeroaffaire && item.parameters.numeroaffaire.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.pdlname && item.parameters.pdlname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.ordertype && memberorderTypeData.find((x) => x.id == item.parameters.ordertype) && memberorderTypeData.find((x) => x.id == item.parameters.ordertype).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.status && memberorderStatusData.find((x) => x.id == item.parameters.status) && memberorderStatusData.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.author && item.parameters.author.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.marketmembershipnumber && item.parameters.marketmembershipnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.marketmembershipname && item.parameters.marketmembershipname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.startdate && moment(item.parameters.startdate).isValid() && moment(item.parameters.startdate).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.enddate && moment(item.parameters.enddate).isValid() && moment(item.parameters.enddate).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.creationdate && moment(item.parameters.creationdate).isValid() && moment(item.parameters.creationdate).format("DD/MM/YYYY hh:mm").includes(filterText))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const electricity = market?.parameters?.general?.energy === "electricity";
    const gas = market?.parameters?.general?.energy === "gas";

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedOrders.map((item) => {
      let ordertoexport = {};
      ordertoexport[memberorder.ordertype] = memberorderTypeData.find((x) => x.id == item.parameters.ordertype)?.name;
      ordertoexport[memberorder.numeroaffaire] = item.parameters.numeroaffaire || '';
      ordertoexport[memberorder.creationdate] = (item.parameters.creationdate && moment(item.parameters.creationdate).isValid()) ? moment(item.parameters.creationdate).format("DD/MM/YYYY HH:mm") : "";
      ordertoexport[memberorder.author] = item.parameters.author || '';
      ordertoexport[memberorder.status] = memberorderStatusData.find((x) => x.id == item.parameters.status)?.name || '';
      ordertoexport[memberorder.validationdate] = (item.parameters.validationdate && moment(item.parameters.validationdate).isValid()) ? moment(item.parameters.validationdate).format("DD/MM/YYYY") : "";
      ordertoexport[memberorder.marketmembershipnumber] = item.parameters.marketmembershipnumber || '';
      ordertoexport[memberorder.marketmembershipname] = item.parameters.marketmembershipname || '';
      ordertoexport[memberorder.marketmembershipaddress] = item.parameters.marketmembershipaddress?.description || '';
      ordertoexport[memberorder.marketmembershipsiret] = item.parameters.marketmembershipsiret || '';
      ordertoexport[memberorder.referentname] = item.parameters.referentname || '';
      ordertoexport[memberorder.referentemail] = item.parameters.referentemail || '';
      ordertoexport[memberorder.referentphone] = item.parameters.referentphone || '';
      ordertoexport[memberorder.pdl] = item.parameters.pdl || '';
      ordertoexport["Ancien " + memberorder.pdlname] = item.parameters.pdloldname || '';
      ordertoexport["Ancienne " + memberorder.pdladdress] = item.parameters.pdloldaddress?.description || '';
      ordertoexport["Ancien " + memberorder.pdlusagecode] = item.parameters.pdloldusagecode || '';
      ordertoexport["Nouveau " + memberorder.pdlname] = item.parameters.pdlname || '';
      ordertoexport["Nouvelle " + memberorder.pdladdress] = item.parameters.pdladdress?.description || '';
      ordertoexport["Nouveau " + memberorder.pdlusagecode] = item.parameters.pdlusagecode || '';
      ordertoexport[memberorder.pdlinseecode] = item.parameters.pdlinseecode || '';
      ordertoexport[memberorder.executiondate] = (item.parameters.startdate && moment(item.parameters.startdate).isValid()) ? moment(item.parameters.startdate).format("DD/MM/YYYY") : "";
      ordertoexport[memberorder.enddate] = (item.parameters.enddate && moment(item.parameters.enddate).isValid()) ? moment(item.parameters.enddate).format("DD/MM/YYYY") : "";
      ordertoexport[memberorder.pdldropmeter] = item.parameters.ordertype === 'detach' ? (item.parameters.pdldropmeter ? 'Oui' : 'Non') : "";
      ordertoexport[memberorder.pdlreferenceconsumption] = item.parameters.pdlreferenceconsumption || '';
      ordertoexport[memberorder.billregroupname] = item.parameters.billregroupname || '';
      ordertoexport[memberorder.billregroupcode] = item.parameters.billregroupcode || '';
      ordertoexport[memberorder.billbudgetcode] = item.parameters.billbudgetcode || '';
      electricity && (ordertoexport[memberorder.renewablemix] = memberorderElectricityRenewableMix.find((x) => x.id == item.parameters.renewablemix)?.name || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.pdltype] = memberorderElectricitySegment.find((x) => x.id == item.parameters.pdloldcontractualdata?.pdltype)?.name || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.turpe] = memberorderElectricityTurpeVersionC5.find((x) => x.id == item.parameters.pdloldcontractualdata?.turpe)?.name || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.psousbase] = item.parameters.pdloldcontractualdata?.psousbase || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.psoushp] = item.parameters.pdloldcontractualdata?.psoushp || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.psoushc] = item.parameters.pdloldcontractualdata?.psoushc || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.psoushph] = item.parameters.pdloldcontractualdata?.psoushph || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.psoushch] = item.parameters.pdloldcontractualdata?.psoushch || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.psoushpe] = item.parameters.pdloldcontractualdata?.psoushpe || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.psoushce] = item.parameters.pdloldcontractualdata?.psoushce || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.psouspointe] = item.parameters.pdloldcontractualdata?.psouspointe || "");
      electricity && (ordertoexport["Contrat actuel - " + memberorder.electricity.nbhour] = memberorderElectricityEclHourCount.find((x) => x.id == item.parameters.pdloldcontractualdata?.nbhour)?.name || "");
      gas && (ordertoexport["Contrat actuel - " + memberorder.gas.profil] = memberorderGasProfil.find((x) => x.id == item.parameters.pdloldcontractualdata?.profil)?.name || "");
      gas && (ordertoexport["Contrat actuel - " + memberorder.gas.tarif] = memberorderGasTariff.find((x) => x.id == item.parameters.pdloldcontractualdata?.tarif)?.name || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.pdltype] = memberorderElectricitySegment.find((x) => x.id == item.parameters.pdlcontractualdata?.pdltype)?.name || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.turpe] = memberorderElectricityTurpeVersionC5.find((x) => x.id == item.parameters.pdlcontractualdata?.turpe)?.name || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.psousbase] = item.parameters.pdlcontractualdata?.psousbase || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.psoushp] = item.parameters.pdlcontractualdata?.psoushp || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.psoushc] = item.parameters.pdlcontractualdata?.psoushc || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.psoushph] = item.parameters.pdlcontractualdata?.psoushph || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.psoushch] = item.parameters.pdlcontractualdata?.psoushch || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.psoushpe] = item.parameters.pdlcontractualdata?.psoushpe || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.psoushce] = item.parameters.pdlcontractualdata?.psoushce || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.psouspointe] = item.parameters.pdlcontractualdata?.psouspointe || "");
      electricity && (ordertoexport["Contrat souhaité - " + memberorder.electricity.nbhour] = memberorderElectricityEclHourCount.find((x) => x.id == item.parameters.pdlcontractualdata?.nbhour)?.name || "");
      gas && (ordertoexport["Contrat souhaité - " + memberorder.gas.profil] = memberorderGasProfil.find((x) => x.id == item.parameters.pdlcontractualdata?.profil)?.name || "");
      gas && (ordertoexport["Contrat souhaité - " + memberorder.gas.tarif] = memberorderGasTariff.find((x) => x.id == item.parameters.pdlcontractualdata?.tarif)?.name || "");
      return ordertoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {markets_update && (
          <UploadButton type="button" onClick={handleClear}>
            <CreateServiceOrder refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedOrders || selectedOrders.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedOrders]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedOrders
  };
}
